import type { MaybeRefOrGetter } from "vue";
import type { AssessmentSituation } from "@/types/campaign";

const AVATAR_PATH = "/images/pnjs/";

function capitalize(value?: string): string {
  return value ? value.charAt(0).toUpperCase() + value.slice(1) : "";
}

// persona_profile_picture is either a file name in /images/pnjs/ or an absolute path/URL
function avatarUrl(picture: string): string {
  return /^(https?:)?\//.test(picture) ? picture : AVATAR_PATH + picture;
}

// Situation display texts come from the situation's ui field.
// Situations without ui (older campaigns) fall back to the situation id and the app meta_human.
export function useSituationContent(situation: MaybeRefOrGetter<AssessmentSituation>) {
  return computed(() => {
    const s = toValue(situation);
    const ui = s.ui;
    const metaHuman = s.app?.meta_human;
    const picture = ui?.persona_profile_picture || (metaHuman ? `${metaHuman}.png` : "");

    return {
      name: ui?.name || s.id,
      persona: ui?.persona || capitalize(metaHuman) || s.id,
      role: ui?.persona_job || "",
      instructions: ui?.description || "",
      avatar: picture ? avatarUrl(picture) : "",
    };
  });
}
